import { lazy } from 'react'

export const UsersChoiceV1 = lazy(() => import('./v1/UsersChoiceV1'))
export const UsersChoiceV2 = lazy(() => import('./v2/UsersChoiceV2'))
export const UsersChoiceV3 = lazy(() => import('./v3/UsersChoiceV3'))
export const UsersChoiceV4 = lazy(() => import('./v4/UsersChoiceV4'))
export const UsersChoiceV5 = lazy(() => import('./v5/UsersChoiceV5'))
